import { render } from "./ReceiptShow.vue?vue&type=template&id=01092007"
import script from "./ReceiptShow.vue?vue&type=script&lang=js"
export * from "./ReceiptShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__